import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsTaxIdWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_TAX_ID;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsTaxIdWUT
};
//# sourceMappingURL=contacts-tax-id-wut.js.map
